module.exports = __webpack_public_path__ + "55def60e19784ebb34680cc9289d70af.png";